import gmx_zMixins         from '../../../../../includes/Jmixins/zMixins'
import func_Gauge           from '../../../../../includes/Jmixins/fCharts/func_Gauge'
import func_Tube           from '../../../../../includes/Jmixins/fCharts/func_Tube'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData            from '../primitives/localData'
import lmx_watching             from './watching'

// Charts 
import lmx_LocalValues          from './set_LocalValues'

import lmx_draw_Forms           from './draw_Forms'

import lmx_status_Area          from './status_Area'

import lmx_Reflash              from './Reflash'
import lmx_events               from './Events'

import lmx_draw_PDF             from './draw_PDF'

export default {
  
  mixins: [
    gmx_zMixins, 
    func_Gauge,
    func_Tube,
    
    // Local Mixins
    lmx_localData,
    lmx_watching,
    lmx_LocalValues,
    lmx_events,
    lmx_Reflash,

    lmx_draw_Forms,

    lmx_status_Area,
    
    lmx_draw_PDF,
  ],

}
